export default{
// API_ENDPOINT: 'http://localhost:8000/api',
API_ENDPOINT: 'https://kraig-overlays-server.herokuapp.com/api' || 'http://localhost:8000/api',
TOKEN_KEY: 'overlays-client-auth-token'
    
}